import { useInfiniteQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';

export const useCommunicationList = (selectedTab: string, limit = 10) => {
  return useInfiniteQuery({
    queryKey: ['communication-list', selectedTab],
    queryFn: async ({ pageParam = 1 }) => {
      const payload = {
        pageNumber: pageParam,
        limit,
        communicationTypeFilter: selectedTab ? [selectedTab] : ['ALL'],
      };
      const { data } = await axiosInstance().post('/communication/getListOfCommunicationMessages', payload);
      return {
        list: data?.data?.listOfCommunicationMessages || [],
        tabCounts: data?.data?.tabCounts || {},
        totalCount: data?.data?.totalCount || 0,
        totalPages: data?.data?.totalPages || 0,
        pageNumber: pageParam,
      };
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.pageNumber < lastPage.totalPages) {
        return lastPage.pageNumber + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
    refetchOnWindowFocus: false,
  });
};
